(function () {
  var COLOUR_PARAM = /colou?r/i;
  var SOLD_OUT = '.grid-product__tag--sold-out';
  var ID_PREFIX = 'id:';
  var CACHE_PREFIX = 'colour-usable:v2:';
  var HIDDEN_FLAG = 'colourHidden';
  var MAX_PAGES = 5;

  var usableColours = null;

  function norm(value) {
    return (value || '').trim().toLowerCase();
  }

  function localeRoot() {
    var match = window.location.pathname.match(/^(.*)\/collections\//);
    return match ? match[1] : '';
  }

  function filterInputs(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('.filter-form input[name]'));
  }

  function looksLikeColour(input) {
    return COLOUR_PARAM.test(input.name);
  }

  function labelOf(input) {
    var li = input.closest('li');
    if (!li) return '';

    var swatch = li.querySelector('.color-swatch');
    if (swatch && swatch.getAttribute('title')) return swatch.getAttribute('title');

    var text = li.querySelector('.tag__text');
    return text ? text.textContent : '';
  }

  function keysOf(input) {
    var value = norm(input.value);
    var label = norm(labelOf(input));
    var id = value.split('/').pop();

    var keys = { id: null, names: [] };

    if (id && id !== value) {
      keys.id = ID_PREFIX + id;
    } else if (value) {
      keys.names.push(value);
    }

    if (label && label !== value) keys.names.push(label);
    return keys;
  }

  function matchedById(input, usable) {
    var id = keysOf(input).id;
    return !!id && usable[id] === true;
  }

  function matchedByName(input, usable) {
    return keysOf(input).names.some(function (key) {
      return usable[key] === true;
    });
  }

  function isUsable(input, usable) {
    return matchedByName(input, usable) || matchedById(input, usable);
  }

  function collectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^\/?]+)/);
    return match ? match[1] : null;
  }

  function sectionId() {
    var loop = document.querySelector('[id^="featured-collection-Loop-"]');
    if (loop) return loop.id.replace('featured-collection-Loop-', '');

    var container = document.querySelector('[data-section-type="collection-grid"][data-section-id]');
    return container ? container.getAttribute('data-section-id') : null;
  }

  function cacheKey(handle) {
    var country = (window.Shopify && window.Shopify.country) || '';
    return CACHE_PREFIX + country + ':' + localeRoot() + '/' + handle;
  }

  function readCache(handle) {
    try {
      var raw = window.sessionStorage.getItem(cacheKey(handle));
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeCache(handle, values) {
    try {
      window.sessionStorage.setItem(cacheKey(handle), JSON.stringify(values));
    } catch (e) {}
  }

  function pageUrl(handle, section, pageNumber) {
    return localeRoot() + '/collections/' + handle +
      '?section_id=' + encodeURIComponent(section) +
      '&page=' + pageNumber;
  }

  function fetchUsableColours(handle, section) {
    var found = [];

    function loadPage(pageNumber) {
      return fetch(pageUrl(handle, section, pageNumber), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) return Promise.reject('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var dom = new DOMParser().parseFromString(html, 'text/html');
          var cards = dom.querySelectorAll('[data-product-handle]');

          cards.forEach(function (card) {
            if (card.querySelector(SOLD_OUT)) return;

            card.querySelectorAll('.color-swatch[data-color]').forEach(function (swatch) {
              var value = norm(swatch.getAttribute('data-color'));
              if (value) found.push(value);

              var gid = swatch.getAttribute('data-color-id');
              if (gid) found.push(ID_PREFIX + gid);
            });
          });

          if (cards.length && pageNumber < MAX_PAGES) {
            return loadPage(pageNumber + 1);
          }
          return found;
        });
    }

    return loadPage(1);
  }

  function groupRows(scope) {
    var groups = {};

    filterInputs(scope).forEach(function (input) {
      var li = input.closest('li');
      if (!li) return;
      (groups[input.name] = groups[input.name] || []).push({ input: input, li: li });
    });

    return groups;
  }

  function countUsable(rows, usable) {
    return rows.filter(function (row) {
      return isUsable(row.input, usable);
    }).length;
  }

  function colourParams(groups, usable) {
    var names = Object.keys(groups);

    var named = names.filter(function (name) {
      return groups[name].some(function (row) {
        return looksLikeColour(row.input);
      });
    });
    if (named.length) return named;

    var best = null;
    var bestCount = 0;

    names.forEach(function (name) {
      var count = countUsable(groups[name], usable);
      if (count > bestCount) {
        bestCount = count;
        best = name;
      }
    });

    return bestCount >= 2 ? [best] : [];
  }

  function applyToGroup(rows, usable) {
    var decided = rows
      .filter(function (row) {
        var keys = keysOf(row.input);
        return !row.input.checked && (keys.id || keys.names.length);
      })
      .map(function (row) {
        return { li: row.li, usable: isUsable(row.input, usable) };
      });

    if (!decided.some(function (row) { return row.usable; })) return;

    decided.forEach(function (row) {
      if (!row.usable) {
        if (!row.li.classList.contains('hide')) {
          row.li.classList.add('hide');
          row.li.dataset[HIDDEN_FLAG] = 'true';
        }
      } else if (row.li.dataset[HIDDEN_FLAG] === 'true') {
        row.li.classList.remove('hide');
        delete row.li.dataset[HIDDEN_FLAG];
      }
    });
  }

  function apply() {
    if (!usableColours || !usableColours.length) return;

    var usable = {};
    usableColours.forEach(function (value) {
      usable[value] = true;
    });

    var groups = groupRows(document);
    colourParams(groups, usable).forEach(function (name) {
      applyToGroup(groups[name], usable);
    });
  }

  function run() {
    if (!filterInputs(document).length) return;

    if (usableColours) {
      apply();
      return;
    }

    var handle = collectionHandle();
    var section = sectionId();
    if (!handle || !section) return;

    var cached = readCache(handle);
    if (cached) {
      usableColours = cached;
      apply();
      return;
    }

    fetchUsableColours(handle, section)
      .then(function (values) {
        if (!values.length) return;
        usableColours = values;
        writeCache(handle, values);
        apply();
      })
      .catch(function (err) {
        console.warn('[colour-availability] could not scan the grid, keeping all colours visible', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('collection:reloaded', run);

  window.__colourAvailabilityDebug = function () {
    var handle = collectionHandle();
    var section = sectionId();

    console.log('Locale root:', localeRoot() || '(primary)');
    console.log('Collection handle:', handle);
    console.log('Section id:', section);

    if (!handle || !section) {
      return console.warn('Not a collection page, or the grid section was not found.');
    }
    console.log('Fetch URL:', pageUrl(handle, section, 1));

    return fetchUsableColours(handle, section).then(function (values) {
      var usable = {};
      values.forEach(function (v) { usable[v] = true; });

      var vocabulary = Object.keys(usable);
      console.log('Colours found in the grid:', vocabulary.length, vocabulary);

      var groups = groupRows(document);
      var targets = colourParams(groups, usable);
      console.log('Filter params on the page:', Object.keys(groups));
      console.log('Treated as colour:', targets.length ? targets : '(none - nothing will be hidden)');

      targets.forEach(function (name) {
        var seen = {};
        var rows = [];

        groups[name].forEach(function (row) {
          var key = norm(row.input.value);
          if (seen[key]) return;
          seen[key] = true;

          rows.push({
            value: key,
            label: norm(labelOf(row.input)),
            checked: row.input.checked,
            usable: isUsable(row.input, usable)
          });
        });

        var hidden = rows.filter(function (r) { return !r.usable && !r.checked; });
        console.log('--- ' + name + ': ' + rows.length + ' values, ' +
          (rows.length - hidden.length) + ' kept, ' + hidden.length + ' hidden');
        console.table(rows);
      });
    });
  };
  window.__colourAvailabilityVerify = function () {
    var handle = collectionHandle();
    var section = sectionId();

    if (!handle || !section) {
      return console.warn('Not a collection page, or the grid section was not found.');
    }

    var cachedSize = usableColours ? usableColours.length : 0;

    return fetchUsableColours(handle, section).then(function (values) {
      var usable = {};
      values.forEach(function (value) {
        usable[value] = true;
      });

      var groups = groupRows(document);
      var targets = colourParams(groups, usable);
      var probes = [];

      targets.forEach(function (name) {
        var seen = {};

        groups[name].forEach(function (row) {
          var key = norm(row.input.value);
          if (!key || seen[key] || row.input.checked) return;
          seen[key] = true;

          var usableFresh = isUsable(row.input, usable);
          var visibleNow = !row.li.classList.contains('hide');

          if (!usableFresh && !visibleNow) return;

          probes.push({
            param: name,
            value: row.input.value,
            id: String(row.input.value).split('/').pop(),
            label: labelOf(row.input),
            usableFresh: usableFresh,
            visibleNow: visibleNow
          });
        });
      });

      var seenRow = {};
      var totalRows = 0;
      var hiddenRows = 0;

      targets.forEach(function (name) {
        groups[name].forEach(function (row) {
          var key = norm(row.input.value);
          if (!key || seenRow[key]) return;
          seenRow[key] = true;

          totalRows++;
          if (row.li.classList.contains('hide')) hiddenRows++;
        });
      });

      var missing = {};
      document.querySelectorAll('.color-swatch[data-color]').forEach(function (swatch) {
        if (swatch.getAttribute('data-color-id')) return;

        var value = norm(swatch.getAttribute('data-color'));
        if (value) missing[value] = true;
      });

      var missingList = Object.keys(missing);
      if (missingList.length) {
        console.warn(missingList.length + ' colour name(s) on this page carry no taxonomy id, so they ' +
          'fall back to name matching and will misbehave on a translated storefront:', missingList);
      }

      console.log('Vocabulary: ' + cachedSize + ' cached (what the page applied), ' +
        values.length + ' fresh (what this probe fetched)');
      if (cachedSize && cachedSize !== values.length) {
        console.warn('Cached and fresh vocabularies differ. The filter you see was built from the ' +
          'cached one, this table from the fresh one, so the two counts will not line up. ' +
          'Clear sessionStorage and reload before trusting either.');
      }
      console.log('Colour rows: ' + totalRows + ' total, ' + (totalRows - hiddenRows) +
        ' visible, ' + hiddenRows + ' hidden by the script');

      console.log('Probing ' + probes.length + ' colours the filter keeps, one request each...');
      var results = [];

      var chain = probes.reduce(function (previous, probe) {
        return previous.then(function () {
          var url = localeRoot() + '/collections/' + handle +
            '?section_id=' + encodeURIComponent(section) +
            '&' + encodeURIComponent(probe.param) + '=' + encodeURIComponent(probe.value);

          return fetch(url, { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) return Promise.reject('HTTP ' + response.status);
              return response.text();
            })
            .then(function (html) {
              var dom = new DOMParser().parseFromString(html, 'text/html');
              var cards = dom.querySelectorAll('[data-product-handle]');
              var wanted = norm(probe.label);
              var showingGid = 0;
              var showingName = 0;
              var soldOut = 0;
              var seenGids = {};

              cards.forEach(function (card) {
                if (card.querySelector(SOLD_OUT)) soldOut++;

                var swatches = card.querySelectorAll('.color-swatch[data-color]');

                var byGid = probe.id && Array.prototype.some.call(swatches, function (swatch) {
                  return swatch.getAttribute('data-color-id') === probe.id;
                });
                var byName = Array.prototype.some.call(swatches, function (swatch) {
                  if (norm(swatch.getAttribute('data-color')) !== wanted) return false;
                  seenGids[swatch.getAttribute('data-color-id') || '(none)'] = true;
                  return true;
                });

                if (byGid) showingGid++;
                if (byName) showingName++;
              });

              results.push({
                label: probe.label,
                visibleNow: probe.visibleNow,
                usableFresh: probe.usableFresh,
                products: cards.length,
                showingGid: showingGid,
                showingName: showingName,
                soldOut: soldOut,
                filterGid: probe.id,
                gridGid: Object.keys(seenGids).join(' ')
              });
            })
            .catch(function (err) {
              results.push({
                label: probe.label,
                visibleNow: probe.visibleNow,
                usableFresh: probe.usableFresh,
                products: 'error',
                showingGid: 0,
                showingName: 0,
                soldOut: String(err)
              });
            });
        });
      }, Promise.resolve());

      return chain.then(function () {
        console.table(results);

        var empty = results.filter(function (result) {
          return result.products === 0;
        });
        var mismatched = results.filter(function (result) {
          return result.products > 0 && result.showingGid === 0 && result.showingName === 0;
        });

        if (empty.length) {
          console.warn(empty.length + ' colour(s) return no products at all:', empty.map(function (result) {
            return result.label || result.value;
          }));
        }
        if (mismatched.length) {
          console.warn(mismatched.length + ' colour(s) return products that show no swatch of that colour:',
            mismatched.map(function (result) { return result.label; }));
        }

        var wrongGid = results.filter(function (result) {
          return result.showingGid === 0 && result.showingName > 0;
        });

        if (wrongGid.length) {
          console.warn(wrongGid.length + ' colour(s) match by name but not by taxonomy id. The grid carries a ' +
            'different id than the filter sends, so product-swatches.js empties the grid for them:');
          console.table(wrongGid.map(function (result) {
            return { label: result.label, filterGid: result.filterGid, gridGid: result.gridGid };
          }));
        }
        var stale = results.filter(function (result) {
          return result.visibleNow && !result.usableFresh;
        });

        if (stale.length) {
          console.warn(stale.length + ' colour(s) are on screen but the fresh scan says they are not usable. ' +
            'These are the dead colours, and they are visible because the page applied a stale cached ' +
            'vocabulary:', stale.map(function (result) { return result.label; }));
        }
        if (!empty.length && !mismatched.length && !stale.length) {
          console.log('Every colour the filter keeps returns products that actually show it.');
        }

        return results;
      });
    });
  };
})();
